import { render, staticRenderFns } from "./PolicyDefinition.vue?vue&type=template&id=83e65d16"
import script from "./PolicyDefinition.vue?vue&type=script&lang=js"
export * from "./PolicyDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports